import useTranslation from "../../hooks/useTranslation";
import { Activity } from "../../models/activity";
import SurveyDispatchManager from "../../models/surveyDispatchManager";
import { ActionPlanIllustration } from "../../styles/illustrations/ActionPlanIllustration";
import { ActionPlanOverview } from "../ActionPlanOverview/ActionPlanOverview";
import { previewActivitiesData } from "../ActionPlanTimeline/ActionPlan.data";
import { DashboardWidget } from "../ui/DashboardWidget/DashboardWidget";

interface ActionPlanWidgetProps {
  dispatchManager?: SurveyDispatchManager;
  activities?: Activity[];
  error?: boolean;
  isLoading?: boolean;
  preview?: boolean;
  hasSurveyAccess?: boolean;
  now: Date;
  onActivitiesRefetch?: () => void;
}
export const ActionPlanWidget = ({
  dispatchManager,
  activities,
  error,
  isLoading,
  preview,
  hasSurveyAccess,
  now,
  onActivitiesRefetch,
}: ActionPlanWidgetProps) => {
  const { t } = useTranslation("dashboardPage");

  if (preview) {
    activities = previewActivitiesData;
    error = false;
    isLoading = false;
  }
  return (
    <DashboardWidget
      title={t("actionPlanWidget.title")}
      icon={ActionPlanIllustration}
      className="ActionPlanWidget"
      preview={preview}
    >
      <ActionPlanOverview
        dispatchManager={dispatchManager}
        activities={activities}
        error={error}
        isLoading={isLoading}
        hasSurveyAccess={preview || hasSurveyAccess}
        now={now}
        onActivitiesRefetch={onActivitiesRefetch}
      />
    </DashboardWidget>
  );
};
